import Vue from 'vue'
import iView from 'view-design'
import locale from 'view-design/dist/locale/en-US'

Vue.use(iView, { locale })

import '../iview-variables.less'
